// CheckedActionTypes

import { ActionCreatorWithPayload, AsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

export type CheckedActionTypes =
  | ActionCreatorWithPayload<any>
  | AsyncThunk<AxiosResponse<any>, any, any>['pending' | 'fulfilled' | 'rejected'];

export function checkActionsType<T extends CheckedActionTypes>(
  action: PayloadAction<any>,
  checkedActions: T[]
): action is ReturnType<(typeof checkedActions)[number]> {
  return checkedActions.some(checkedAction => action.type === checkedAction.type);
}
